/**
 * guards/UserRoute.jsx
 * Allows only regular users and admins.
 * Mentors are redirected to /mentordashboard.
 * Unauthenticated users go to /.
 */
import { Navigate } from "react-router-dom";

export default function UserRoute({ user, role, children }) {
  if (!user) return <Navigate to="/" replace />;
  if (role === "mentor") return <Navigate to="/mentordashboard" replace />;
  return children;
}